import { loadAddress, useAddressDialog } from "src/store/address-dialog";
import { init, useMetaMask } from "src/store/metamask";
import connect from "./connect";
import getAddresses from "./get-address";
import { NO_ACCOUNTS, NO_PROVIDER, createWalletError, reportWalletFailure } from "./wallet-error";

const useSetup = () => {
  const [_, dispatch] = useAddressDialog();
  const [__, metamaskDispatch] = useMetaMask();

  async function setup() {
    if (!window.ethereum) {
      await reportWalletFailure(
        "looking for a wallet",
        createWalletError(NO_PROVIDER, "window.ethereum is undefined")
      );
      return false;
    }

    // Stage 1: ask MetaMask for accounts. This is the only stage where the
    // user can genuinely deny access, so it gets its own catch.
    let addresses;
    try {
      addresses = await getAddresses();
    } catch (error) {
      await reportWalletFailure("requesting accounts", error);
      return false;
    }

    if (!addresses.length) {
      await reportWalletFailure(
        "requesting accounts",
        createWalletError(NO_ACCOUNTS, "eth_requestAccounts resolved with an empty array")
      );
      return false;
    }

    // Stage 2: switch chain and build the contracts. Failures here are ours,
    // not the user's - they must never be reported as a denial.
    try {
      if (addresses.length > 1) {
        dispatch(loadAddress(addresses));
        return true;
      }

      const connectedData = await connect(addresses[0]);
      metamaskDispatch(init(connectedData));
      return true;
    } catch (error) {
      await reportWalletFailure("preparing the staking contracts", error);
      return false;
    }
  }

  return setup;
};

export default useSetup;
